export const defaultRemoteSigningState = {
	lstCertConnect: [],
	compensCertStatus: null,
	compensCertSuccess: null,
	compensCertLoading: false,
	// Bước cao nhất NSD đã hoàn thành trong quy trình cấp bù CTS (0 = chưa bước nào)
	compensCertStep: 0,
	compensCertData: {},
	// Ngày server gần nhất popup cấp bù CTS đã hiển thị, null nếu chưa từng hiển thị
	compensCertLastShownDate: null,
	// Danh sách chứng thư số được cấp bù đang xử lý
	compensCertList: [],
	// Chứng thư số NSD vừa chọn để kết nối
	selectedCompensCert: null
};

export default {
	...defaultRemoteSigningState
};
